import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} href={link} alt={"company"} />
        <a
          href={link}
          rel="noreferrer"
          target={"_blank"}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
          </div>
        </a>
      </div>
    </Col>
  );
};
